import { AcceptPaymentMethodEnum } from '../../../../enums/AcceptPaymentMethodEnum';
import UPIFormControl from './UPIFormControl';
import BankAccountFormControl from './BankAccountFormConrrol';

const PaymentModeFormSection = ({paymentFormData, updateFormData, updateBankAccountDetails}: any) => {
    switch (paymentFormData.selectedPaymentMode) {
      case AcceptPaymentMethodEnum.UPI:
        return <UPIFormControl updateFormData={updateFormData} paymentFormData={paymentFormData} />
      case AcceptPaymentMethodEnum.BankAccount:
        return <BankAccountFormControl updateBankAccountDetails={updateBankAccountDetails} paymentFormData={paymentFormData}/>
      default:
        return <></>
    }
  }

  export default PaymentModeFormSection;